import { useTranslation } from "react-i18next";
import { useNotificationStore } from "./notificationStore.js";
import { BetToast } from "./BetToast.js";
import { RainToast } from "../chat/RainToast.js";
import { useChatStore } from "../chat/chatStore.js";
export function ToastStack() {
  const { t } = useTranslation();
  const bets = useNotificationStore((state) => state.bets);
  const receipts = useChatStore((state) => state.received);
  return (
    <aside className="cx-toast-stack" aria-label={t("notifications.title")}>
      {receipts.map((receipt) => (
        <RainToast key={receipt.id} receipt={receipt} />
      ))}
      {bets.map((bet) => (
        <BetToast key={bet.betId} bet={bet} />
      ))}
    </aside>
  );
}
